import { Suspense, lazy } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router';

import { LoadingScreen } from '@zeta-core';
import { CompactErrorPage } from '../../layouts/compact-layout';
import { DashboardLayout } from '../../layouts/dashboard-layout';

const FactfindPublicPage = lazy(() => import('../../pages/public-pages/factfind-session'));

const PublicRoutes = [
  {
    path: '',
    element: (
      <ErrorBoundary FallbackComponent={CompactErrorPage}>
        <Suspense fallback={<LoadingScreen />}>
          <DashboardLayout noData>
            <Outlet />
          </DashboardLayout>
        </Suspense>
      </ErrorBoundary>
    ),
    children: [{ path: 'factfind', element: <FactfindPublicPage /> }],
  },
];

export default PublicRoutes;
